import styled from 'styled-components';

const ColoredSpan = styled.span`
  color: ${({ color }) => color};
  > * > svg {
    color: ${({ color }) => color};
  }
`;

export default ColoredSpan;
